import { queryClient } from "@/queryClient";
import { toast } from "react-toastify";
import { useDomainMutation } from "@/modules/common/hooks/domain-mutation.hook";
import { addBrokerShowing } from "../../api";

export interface AddBrokerShowingPayload {
  brokerUid: string;
  showingDate: string;
  tenantName: string;
}

const useAddBrokerShowing = ({
  trackUId,
  onSuccess,
}: {
  trackUId: string;
  onSuccess?: () => void;
}) => {
  const mutation = useDomainMutation(
    (data: AddBrokerShowingPayload) => addBrokerShowing({ trackUId, data }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ["track"] });
        toast.success("Broker showing added successfully", {
          position: "bottom-left",
          autoClose: 3000,
        });
        onSuccess?.();
      },
      onError: () => {
        toast.error("Failed to add broker showing", {
          position: "bottom-left",
          autoClose: 3000,
        });
      },
    },
  );

  return {
    addBrokerShowing: mutation.mutate,
    isAddingBrokerShowing: mutation.isPending,
  };
};

export default useAddBrokerShowing;
